module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error403-wrapper"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/index"
    }
  }, [_vm._v("返回首页")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("\n      返回上页\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "error-con"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-1c726112"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/notFound/notFound.vue
// module id = 885
// module chunks = 9